module.exports = __webpack_public_path__ + "static/media/mari_desktop4.a76e9d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_desktop4.png
// module id = 93
// module chunks = 0